import React from "react";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { PendingActionData } from "../../types";
import { AdminHomeCustomIcon } from "../shared/adminHomeIcons";

type AdminPendingActionsCardProps = {
  actions: PendingActionData[];
  onActionClick?: (id: string) => void;
};

const AdminPendingActionsCard: React.FC<AdminPendingActionsCardProps> = ({
  actions,
  onActionClick,
}) => {
  return (
    <div className="admin-home-pending">
      <h3 className="admin-home-pending__title">Pending Actions</h3>
      <ul className="admin-home-pending__list">
        {actions.map((action) => (
          <li
            key={action.id}
            className={
              action.isStaticDisabled
                ? "admin-home-pending__list-item--static-disabled"
                : undefined
            }
          >
            <button
              type="button"
              className={`admin-home-pending__item${
                action.isStaticDisabled
                  ? " admin-home-pending__item--static-disabled"
                  : ""
              }`}
              disabled={action.isStaticDisabled}
              onClick={() => {
                if (!action.isStaticDisabled) {
                  onActionClick?.(action.id);
                }
              }}
            >
              <span className="admin-home-pending__icon">
                {action.customIcon ? (
                  <AdminHomeCustomIcon
                    name={action.customIcon}
                    width={20}
                    height={20}
                  />
                ) : action.icon ? (
                  <Iconography
                    icon={action.icon}
                    size={IconographySizes.Small}
                  />
                ) : null}
              </span>
              <span className="admin-home-pending__text">
                <span className="admin-home-pending__label">{action.title}</span>
                <span className="admin-home-pending__subtitle">
                  {action.subtitle}
                </span>
              </span>
              <span className="admin-home-pending__trail">
                <span className="admin-home-pending__count">{action.count}</span>
                <Iconography
                  icon="chevronRight"
                  size={IconographySizes.Small}
                  className="admin-home-pending__chevron"
                />
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AdminPendingActionsCard;
